<template>
<div class="chapter">
<div class="inner_page">
<div class="ph" id="pgepubid00001">
<h2 class="nobreak" id="calibre_pb_0">CONTENTS</h2>
</div>
<table class="autotable">
<tbody class="calibre4"><tr class="calibre5"><td class="tdr">I</td>
<td class="tdl"><a href="#/OEBPS/Text/Section002_split_002#CHAPTER_I"><span class="smcap">The Haunted House</span></a></td>
</tr>
<tr class="calibre5"><td class="tdr">II</td>
<td class="tdl"><a href="#/OEBPS/Text/Section003#CHAPTER_II"><span class="smcap">The Storm</span></a></td>
</tr>
<tr class="calibre5"><td class="tdr">III</td>
<td class="tdl"><a href="#/OEBPS/Text/Section004#CHAPTER_III"><span class="smcap">Empty Tool Boxes</span></a></td>
</tr>
<tr class="calibre5"><td class="tdr">IV</td>
<td class="tdl"><span href="#/OEBPS/Text/Section005#CHAPTER_IV" title="Link target outside of Sample"><span class="smcap">The Chase in the Bay</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">V</td>
<td class="tdl"><span href="#/OEBPS/Text/Section006#CHAPTER_V" title="Link target outside of Sample"><span class="smcap">The Rescue</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">VI</td>
<td class="tdl"><span href="#/OEBPS/Text/Section007#CHAPTER_VI" title="Link target outside of Sample"><span class="smcap">Snackley</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">VII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section008#CHAPTER_VII" title="Link target outside of Sample"><span class="smcap">Bound and Gagged</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">VIII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section009#CHAPTER_VIII" title="Link target outside of Sample"><span class="smcap">The Stolen Witness</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">IX</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0010#CHAPTER_IX" title="Link target outside of Sample"><span class="smcap">The Strange Message</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">X</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0011#CHAPTER_X" title="Link target outside of Sample"><span class="smcap">The Vain Search</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XI</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0012#CHAPTER_XI" title="Link target outside of Sample"><span class="smcap">The Cap on the Peg</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0013#CHAPTER_XII" title="Link target outside of Sample"><span class="smcap">Pointed Questions</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XIII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0014#CHAPTER_XIII" title="Link target outside of Sample"><span class="smcap">A Plan of Attack</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XIV</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0015#CHAPTER_XIV" title="Link target outside of Sample"><span class="smcap">Private Property</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XV</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0016#CHAPTER_XV" title="Link target outside of Sample"><span class="smcap">Smugglers</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XVI</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0017#CHAPTER_XVI" title="Link target outside of Sample"><span class="smcap">The Secret Passage</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XVII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0018#CHAPTER_XVII" title="Link target outside of Sample"><span class="smcap">The Chamber in the Cliff</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XVIII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0019#CHAPTER_XVIII" title="Link target outside of Sample"><span class="smcap">A Startling Discovery</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XIX</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0020#CHAPTER_XIX" title="Link target outside of Sample"><span class="smcap">Captured</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XX</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0021#CHAPTER_XX" title="Link target outside of Sample"><span class="smcap">Dire Threats</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XXI</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0022#CHAPTER_XXI" title="Link target outside of Sample"><span class="smcap">Quick Work</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XXII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0023#CHAPTER_XXII" title="Link target outside of Sample"><span class="smcap">Into the Haunted House</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XXIII</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0024#CHAPTER_XXIII" title="Link target outside of Sample"><span class="smcap">Rescue</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XXIV</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0025#CHAPTER_XXIV" title="Link target outside of Sample"><span class="smcap">The Round-Up</span></span></td>
</tr>
<tr class="calibre5"><td class="tdr">XXV</td>
<td class="tdl"><span href="#/OEBPS/Text/Section0026#CHAPTER_XXV" title="Link target outside of Sample"><span class="smcap">The Mystery Explained</span></span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section001.vue?cb3561d2